(function($) {
    var dropcapElement = $('.paragraph-dropcap p').contents().filter(function () { return this.nodeType == 3 }).first(),
        text = dropcapElement.text().trim(),
        firstLetter = text.slice(0, 1);

    if (!dropcapElement.length)
        return;

    dropcapElement[0].nodeValue = text.slice(firstLetter.length);
    dropcapElement.before('<span class="dropcap">' + firstLetter + '</span>');
})(jQuery);
